import React from 'react';

import type { Props } from '@swf/components/Inputs/StarsDropDown';
import StarsDropDown from '@swf/components/Inputs/StarsDropDown';

import useDisableField from '../../../../hooks/useDisableField';

const RMFDropDown: React.FC<Props> = ({ id, disabled, ...props }) => {
  const disableField = useDisableField();

  return <StarsDropDown id={id} disabled={disabled || disableField(id)} {...props} />;
};
export default RMFDropDown;
